import { useEffect, useRef } from 'react';

/**
 * Hook that handles clicks outside of a specific element
 * @param {Function} callback - Function to call when clicking outside
 * @param {boolean} isActive - Whether the hook should be active
 * @returns {Object} ref - Ref to attach to the element that should detect outside clicks
 */
export const useClickOutside = (callback, isActive = true) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!isActive) return;

    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    };

    // Use mousedown instead of click for better UX
    document.addEventListener('mousedown', handleClickOutside);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [callback, isActive]);

  return ref;
};

export default useClickOutside;